$.fn.gridOverlap = function() {
  let self = this
  let section = self.closest('.page-section')
  section.addClass('grid-overlap-wrapper')
  let previous = section.prev('.page-section')
  previous.addClass('grid-overlap-previous')
  previous.css('--grid-height', self.find('.feature').outerHeight() + 'px')

  return function() {
    $(window).on('resize load orientationchange', function(){
      previous.css('--grid-height', self.find('.feature').outerHeight() + 'px')
    })
    return self
  }()
}
